import { render, staticRenderFns } from "./ViewFluxo.vue?vue&type=template&id=5bcc3000&"
import script from "./ViewFluxo.vue?vue&type=script&lang=js&"
export * from "./ViewFluxo.vue?vue&type=script&lang=js&"
import style0 from "./ViewFluxo.vue?vue&type=style&index=0&id=5bcc3000&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports